import React, {useEffect} from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";


import AOS from "aos";
import "aos/dist/aos.css";

function AboutCard() {
  useEffect(() => {
    AOS.init({
      duration: 3000,
    });
  }, []);
  
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Babajanova Sabrina </span>
            from <span className="purple"> Tajikistan, Khujand.</span>
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Singing songs
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Strive to build things that make a difference!"{" "}
          </p>
          <footer className="blockquote-footer">Sabrina</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
